var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from "react";
import { Accordion, Button, Grid, Icon, Input, Select } from "semantic-ui-react";
import { CustomPriceRow } from "../../admin/CustomPriceRow";
import ErrorDisplay from "../../ErrorDisplay";
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import { priceColumn, PriceDisplay } from "../rna-fish/EditKitForm";
import { EnzymeEnum } from "./RnaCatalog";
import { getAmpCatalog, NONE_ENZYME, NONE_HAPTEN, NONE_HCR_AMPLIFIER, NONE_ID } from "./RnaCishKitToAdminFormState";
var AmplifierForm = /** @class */ (function (_super) {
    __extends(AmplifierForm, _super);
    function AmplifierForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toggleScales = function () {
            _this.props.onDetectStateChange(function (_) {
                return {
                    scalesExpanded: !_this.props.detectState.scalesExpanded
                };
            });
        };
        _this.renderNumericField = function (errorPath, label, value, onChange, disabled) {
            return React.createElement(FieldWithErrorDisplay, { errors: _this.props.errors, errorPath: errorPath, labelContent: React.createElement(React.Fragment, null, label) },
                React.createElement(Input, { type: 'number', value: value, onChange: onChange, disabled: disabled }));
        };
        _this.renderChannelDetectScales = function (channelState, index, scalesDisabled) {
            var prefix = index + 1;
            return React.createElement(Grid.Row, { key: index },
                React.createElement(Grid.Column, null, _this.renderNumericField('/amplifierComponent/detectAntiHaptenUl', "Detect D (\u00B5L) " + prefix, channelState.detectAntiHaptenUl, _this.onDetectAntiHaptenUlChange(index), scalesDisabled)),
                React.createElement(Grid.Column, null, _this.renderNumericField('/amplifierComponent/detectTyramideUl', "Detect E (\u00B5L) " + prefix, channelState.detectTyramideUl, _this.onDetectTyramideUlChange(index), scalesDisabled)),
                React.createElement(Grid.Column, null, _this.renderNumericField('/amplifierComponent/detectEnzymeApUl', "Detect F AP (\u00B5L) " + prefix, channelState.detectEnzymeApUl, _this.onDetectEnzymeApUlChange(index), scalesDisabled)),
                React.createElement(Grid.Column, null, _this.renderNumericField('/amplifierComponent/detectEnzymeHrpUl', "Detect F HRP (\u00B5L) " + prefix, channelState.detectEnzymeHrpUl, _this.onDetectEnzymeHrpUlChange(index), scalesDisabled)),
                React.createElement(Grid.Column, null, _this.renderNumericField('/amplifierComponent/detectHrpQuencherUl', "HRP Quencher (\u00B5L) " + prefix, channelState.detectHrpQuencherUl, _this.onDetectHrpQuencherUlChange(index), scalesDisabled)));
        };
        _this.priceDisplay = function () {
            return React.createElement(PriceDisplay, { priceCents: _this.props.priceCents, loading: _this.props.priceLoading });
        };
        _this.onPrefilledChange = function (_, data) {
            _this.props.onDetectStateChange({
                prefilled: data.value
            }, _this.props.onUserSelection);
        };
        _this.onPretreatADewaxUlChange = function (_, data) {
            var val = parseFloat(data.value);
            if (!isNaN(val)) {
                _this.props.onDetectStateChange({ pretreatADewaxUl: val }, _this.props.onUserSelection);
            }
        };
        _this.onPretreatBAntigenRetrievalUlChange = function (_, data) {
            var val = parseFloat(data.value);
            if (!isNaN(val)) {
                _this.props.onDetectStateChange({ pretreatBAntigenRetrievalUl: val }, _this.props.onUserSelection);
            }
        };
        _this.onPretreatBloxolUlChange = function (_, data) {
            var val = parseFloat(data.value);
            if (!isNaN(val)) {
                _this.props.onDetectStateChange({ pretreatBloxolUl: val }, _this.props.onUserSelection);
            }
        };
        _this.onDetectAUlChange = function (_, data) {
            var val = parseFloat(data.value);
            if (!isNaN(val)) {
                _this.props.onDetectStateChange({ detectAUl: val }, _this.props.onUserSelection);
            }
        };
        _this.onDetectBPmolChange = function (_, data) {
            var val = parseFloat(data.value);
            if (!isNaN(val)) {
                _this.props.onDetectStateChange({ detectBPmol: val }, _this.props.onUserSelection);
            }
        };
        _this.onDetectBConcentrationChange = function (_, data) {
            var val = parseFloat(data.value);
            if (!isNaN(val)) {
                _this.props.onDetectStateChange({ detectBConcentration: val }, _this.props.onUserSelection);
            }
        };
        _this.onDetectBUlChange = function (_, data) {
            var val = parseFloat(data.value);
            if (!isNaN(val)) {
                _this.props.onDetectStateChange({ detectBUl: val }, _this.props.onUserSelection);
            }
        };
        _this.onDetectCUlChange = function (_, data) {
            var val = parseFloat(data.value);
            if (!isNaN(val)) {
                _this.props.onDetectStateChange({ detectCUl: val }, _this.props.onUserSelection);
            }
        };
        _this.onPostProcessAUlChange = function (_, data) {
            var val = parseFloat(data.value);
            if (!isNaN(val)) {
                _this.props.onDetectStateChange({ postProcessAUl: val }, _this.props.onUserSelection);
            }
        };
        _this.onPostProcessBUlChange = function (_, data) {
            var val = parseFloat(data.value);
            if (!isNaN(val)) {
                _this.props.onDetectStateChange({ postProcessBUl: val }, _this.props.onUserSelection);
            }
        };
        _this.onPreHybridizationUlChange = function (_, data) {
            var val = parseFloat(data.value);
            if (!isNaN(val)) {
                _this.props.onDetectStateChange({ preHybridizationUl: val }, _this.props.onUserSelection);
            }
        };
        _this.renderChannel = function (channelState, index, ampCatalog, amplifierOptions, haptenOptions, enzymeOptions) {
            var _a, _b;
            var channelNum = (index + 1);
            var configsForChannel = ampCatalog.proAmpConfigList.filter(function (c) {
                return c.channelNum === channelNum &&
                    c.platformCompatibility.find(function (pc) { return pc.id === _this.props.protocolType.id; }) != null;
            });
            var configValue = (_b = (_a = channelState.config) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : -1;
            var configOptions = __spreadArrays(configsForChannel.map(function (c) { return ({
                text: c.enzyme.label + " (" + c.amplifier.id + ")",
                value: c.id
            }); }), (configValue === -1 ? [{ text: '(Custom)', value: -1 }] : []));
            var configField = index === 0 ? 'config' : 'ch2Config';
            var ampField = index === 0 ? 'hcrAmplifier' : 'ch2HcrAmplifier';
            var haptenField = index === 0 ? 'hapten' : 'ch2Hapten';
            var enzymeField = index === 0 ? 'enzyme' : 'ch2Enzyme';
            return React.createElement(React.Fragment, { key: index },
                React.createElement("h4", null,
                    "Channel ",
                    index + 1),
                React.createElement(Grid, { columns: 3, stackable: true },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: 16 },
                            React.createElement(FieldWithErrorDisplay, { errors: _this.props.errors, errorPath: "/amplifierComponent/" + configField, labelContent: React.createElement(React.Fragment, null, "Config") },
                                React.createElement("div", { className: 'presnapcooled-selector' },
                                    React.createElement(Select, { options: configOptions, onChange: _this.onConfigChange(index), value: configValue }),
                                    React.createElement(Button, { basic: true, compact: true, size: 'mini', icon: true, onClick: _this.onEditClick(index), type: 'button' },
                                        React.createElement(Icon, { name: 'pencil' })))))),
                    (channelState.editing || configValue === -1) && (React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: _this.props.errors, errorPath: "/amplifierComponent/" + ampField, labelContent: React.createElement(React.Fragment, null, "Amplifier") },
                                React.createElement(Select, { value: channelState.hcrAmplifier.id, onChange: _this.onAmplifierChange(index), options: amplifierOptions }))),
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: _this.props.errors, errorPath: "/amplifierComponent/" + haptenField, labelContent: React.createElement(React.Fragment, null, "Hapten") },
                                React.createElement(Select, { value: channelState.hapten.id, onChange: _this.onHaptenChange(index), options: haptenOptions, disabled: channelState.hcrAmplifier.id === NONE_ID }))),
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: _this.props.errors, errorPath: "/amplifierComponent/" + enzymeField, labelContent: React.createElement(React.Fragment, null, "Enzyme") },
                                React.createElement(Select, { value: channelState.enzyme.id, onChange: _this.onEnzymeChange(index), options: enzymeOptions })))))),
                channelState.editing && (React.createElement("div", { className: 'amp-label-editor-actions' },
                    React.createElement(Button, { type: 'button', basic: true, size: 'small', onClick: _this.onEditDone(index) }, "Done"))));
        };
        _this.onAmplifierChange = function (channelIndex) {
            return function (_, data) {
                var newAmplifier = _this.findAmplifier(data.value);
                if (newAmplifier) {
                    if (newAmplifier.id === NONE_ID) {
                        _this.props.onDetectStateChange(function (old) { return ({
                            channels: old.channels.map(function (c, i) { return i === channelIndex ? __assign(__assign({}, c), { hcrAmplifier: newAmplifier, hapten: NONE_HAPTEN, config: undefined }) : c; }),
                            detectBPmol: 0,
                            detectBConcentration: 0,
                            detectBUl: 0
                        }); }, _this.props.onUserSelection);
                        return;
                    }
                    var ch = _this.props.detectState.channels[channelIndex];
                    var channelNum = (channelIndex + 1);
                    var newConfig_1 = _this.findConfigForChannel(newAmplifier, ch.hapten, ch.enzyme, channelNum);
                    _this.props.onDetectStateChange(function (old) { return ({
                        channels: old.channels.map(function (c, i) { return i === channelIndex ? __assign(__assign({}, c), { hcrAmplifier: newAmplifier, config: newConfig_1 }) : c; })
                    }); }, _this.props.onUserSelection);
                }
            };
        };
        _this.onHaptenChange = function (channelIndex) {
            return function (_, data) {
                var newHapten = _this.findHapten(data.value);
                if (newHapten) {
                    var ch = _this.props.detectState.channels[channelIndex];
                    var channelNum = (channelIndex + 1);
                    var newConfig_2 = _this.findConfigForChannel(ch.hcrAmplifier, newHapten, ch.enzyme, channelNum);
                    _this.props.onDetectStateChange(function (old) { return ({
                        channels: old.channels.map(function (c, i) { return i === channelIndex ? __assign(__assign({}, c), { hapten: newHapten, config: newConfig_2 }) : c; })
                    }); }, _this.props.onUserSelection);
                }
            };
        };
        _this.onEnzymeChange = function (channelIndex) {
            return function (_, data) {
                var newEnzyme = _this.findEnzyme(data.value);
                if (newEnzyme) {
                    var ch = _this.props.detectState.channels[channelIndex];
                    var channelNum = (channelIndex + 1);
                    var newConfig_3 = _this.findConfigForChannel(ch.hcrAmplifier, ch.hapten, newEnzyme, channelNum);
                    _this.props.onDetectStateChange(function (old) { return ({
                        channels: old.channels.map(function (c, i) { return i === channelIndex ? __assign(__assign(__assign({}, c), { enzyme: newEnzyme, config: newConfig_3 }), _this.scaleUpdatesForEnzyme(newEnzyme, c)) : c; })
                    }); }, _this.props.onUserSelection);
                }
            };
        };
        _this.onDetectAntiHaptenUlChange = function (channelIndex) {
            return function (_, data) {
                var val = parseFloat(data.value);
                if (!isNaN(val)) {
                    _this.props.onDetectStateChange(function (old) { return ({
                        channels: old.channels.map(function (c, i) { return i === channelIndex ? __assign(__assign({}, c), { detectAntiHaptenUl: val }) : c; })
                    }); }, _this.props.onUserSelection);
                }
            };
        };
        _this.onDetectTyramideUlChange = function (channelIndex) {
            return function (_, data) {
                var val = parseFloat(data.value);
                if (!isNaN(val)) {
                    _this.props.onDetectStateChange(function (old) { return ({
                        channels: old.channels.map(function (c, i) { return i === channelIndex ? __assign(__assign({}, c), { detectTyramideUl: val }) : c; })
                    }); }, _this.props.onUserSelection);
                }
            };
        };
        _this.onDetectEnzymeApUlChange = function (channelIndex) {
            return function (_, data) {
                var val = parseFloat(data.value);
                if (!isNaN(val)) {
                    _this.props.onDetectStateChange(function (old) { return ({
                        channels: old.channels.map(function (c, i) { return i === channelIndex ? __assign(__assign({}, c), { detectEnzymeApUl: val }) : c; })
                    }); }, _this.props.onUserSelection);
                }
            };
        };
        _this.onDetectEnzymeHrpUlChange = function (channelIndex) {
            return function (_, data) {
                var val = parseFloat(data.value);
                if (!isNaN(val)) {
                    _this.props.onDetectStateChange(function (old) { return ({
                        channels: old.channels.map(function (c, i) { return i === channelIndex ? __assign(__assign({}, c), { detectEnzymeHrpUl: val }) : c; })
                    }); }, _this.props.onUserSelection);
                }
            };
        };
        _this.onDetectHrpQuencherUlChange = function (channelIndex) {
            return function (_, data) {
                var val = parseFloat(data.value);
                if (!isNaN(val)) {
                    _this.props.onDetectStateChange(function (old) { return ({
                        channels: old.channels.map(function (c, i) { return i === channelIndex ? __assign(__assign({}, c), { detectHrpQuencherUl: val }) : c; })
                    }); }, _this.props.onUserSelection);
                }
            };
        };
        _this.onConfigChange = function (channelIndex) {
            return function (_, data) {
                var selectedId = data.value;
                if (selectedId === -1) {
                    _this.props.onDetectStateChange(function (old) { return ({
                        channels: old.channels.map(function (ch, i) { return i === channelIndex ? __assign(__assign({}, ch), { config: undefined }) : ch; })
                    }); }, _this.props.onUserSelection);
                    return;
                }
                var ampCatalog = getAmpCatalog(_this.props.manualPro, _this.props.plexity, _this.props.catalog.userConfigs);
                var newConfig = ampCatalog.proAmpConfigList.find(function (c) { return c.id === selectedId; });
                if (newConfig) {
                    _this.props.onDetectStateChange(function (old) { return ({
                        channels: old.channels.map(function (ch, i) { return i === channelIndex ? __assign(__assign(__assign({}, ch), { config: newConfig, hcrAmplifier: newConfig.amplifier, hapten: newConfig.hapten, enzyme: newConfig.enzyme, editing: false }), _this.scaleUpdatesForEnzyme(newConfig.enzyme, ch)) : ch; })
                    }); }, _this.props.onUserSelection);
                }
            };
        };
        _this.onEditClick = function (channelIndex) { return function () {
            _this.props.onDetectStateChange(function (old) { return ({
                channels: old.channels.map(function (ch, i) { return i === channelIndex ? __assign(__assign({}, ch), { editing: true }) : ch; })
            }); });
        }; };
        _this.onEditDone = function (channelIndex) { return function () {
            _this.props.onDetectStateChange(function (old) { return ({
                channels: old.channels.map(function (ch, i) { return i === channelIndex ? __assign(__assign({}, ch), { editing: false }) : ch; })
            }); });
        }; };
        _this.findConfigForChannel = function (amplifier, hapten, enzyme, channel) {
            if (amplifier.id === NONE_ID || hapten.id === NONE_ID || enzyme.id === NONE_ID) {
                return undefined;
            }
            return getAmpCatalog(_this.props.manualPro, _this.props.plexity, _this.props.catalog.userConfigs).proAmpConfigList.find(function (e) {
                return e.amplifier.id === amplifier.id &&
                    e.hapten.id === hapten.id &&
                    e.enzyme.id === enzyme.id &&
                    e.channelNum === channel &&
                    e.platformCompatibility.find(function (pc) { return pc.id === _this.props.protocolType.id; }) != null;
            });
        };
        _this.onCustomPriceChange = function (newStateFn, callback) {
            _this.props.onDetectStateChange(function (oldState) { return ({ customPrice: newStateFn(oldState.customPrice) }); }, callback);
        };
        _this.findAmplifier = function (id) {
            return id === NONE_ID ? NONE_HCR_AMPLIFIER : _this.props.catalog.hcrAmplifiers.find(function (a) { return a.id === id; });
        };
        _this.findHapten = function (id) {
            return id === NONE_ID ? NONE_HAPTEN : _this.props.catalog.hapten.find(function (h) { return h.id === id; });
        };
        _this.findEnzyme = function (id) {
            return id === NONE_ID ? NONE_ENZYME : _this.props.catalog.enzymes.find(function (e) { return e.id === id; });
        };
        _this.scaleUpdatesForEnzyme = function (enzyme, channelState) {
            var _a, _b, _c, _d;
            var apScale = channelState.detectEnzymeApUl > 0
                ? channelState.detectEnzymeApUl
                : (_b = (_a = _this.props.detectPresetScale) === null || _a === void 0 ? void 0 : _a.detectEnzymeApUl) !== null && _b !== void 0 ? _b : 1;
            var hrpScale = channelState.detectEnzymeHrpUl > 0
                ? channelState.detectEnzymeHrpUl
                : (_d = (_c = _this.props.detectPresetScale) === null || _c === void 0 ? void 0 : _c.detectEnzymeHrpUl) !== null && _d !== void 0 ? _d : 1;
            if (enzyme.id === NONE_ID) {
                return { detectEnzymeApUl: 0, detectEnzymeHrpUl: 0 };
            }
            if (enzyme.id === EnzymeEnum.AP) {
                return { detectEnzymeApUl: apScale, detectEnzymeHrpUl: 0 };
            }
            if (enzyme.id === EnzymeEnum.HRP) {
                return { detectEnzymeApUl: 0, detectEnzymeHrpUl: hrpScale };
            }
            return { detectEnzymeApUl: apScale, detectEnzymeHrpUl: hrpScale };
        };
        return _this;
    }
    AmplifierForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, detectState = _a.detectState, detectPresetScale = _a.detectPresetScale, lockScales = _a.lockScales, catalog = _a.catalog;
        var scalesExpanded = detectState.scalesExpanded;
        var scalesDisabled = lockScales && detectPresetScale != null;
        var amplifierOptions = catalog.hcrAmplifiers.map(function (a) { return ({ text: a.id, value: a.id }); }).concat([{ text: "NONE", value: NONE_ID }]);
        var haptenOptions = catalog.hapten.map(function (h) { return ({ text: h.id, value: h.id }); }).concat([{ text: "NONE", value: NONE_ID }]);
        var enzymeOptions = catalog.enzymes.map(function (e) { return ({ text: e.label, value: e.id }); }).concat([{ text: "NONE", value: NONE_ID }]);
        var ampCatalog = getAmpCatalog(this.props.manualPro, this.props.plexity, this.props.catalog.userConfigs);
        return React.createElement(React.Fragment, null,
            React.createElement(Grid, { columns: 1 },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { textAlign: 'right' }, detectPresetScale != null
                        ? React.createElement(React.Fragment, null,
                            React.createElement(Icon, { name: 'check circle', color: 'green' }),
                            React.createElement("span", { style: { color: 'green' } }, "Preset scale applied"))
                        : React.createElement(React.Fragment, null,
                            React.createElement(Icon, { name: 'warning sign', color: 'yellow' }),
                            React.createElement("span", { style: { color: '#b58900' } }, "No preset scale applied"))))),
            React.createElement(Grid, { columns: 3, stackable: true },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/amplifierComponent/prefilled', labelContent: React.createElement(React.Fragment, null, "Prefilled") },
                            React.createElement(Select, { options: [
                                    { text: "Ready-to-Use in Dispensers", value: true },
                                    { text: "Reagents Only", value: false }
                                ], onChange: this.onPrefilledChange, value: detectState.prefilled }))))),
            detectState.channels.map(function (channelState, index) {
                return _this.renderChannel(channelState, index, ampCatalog, amplifierOptions, haptenOptions, enzymeOptions);
            }),
            React.createElement(Accordion, null,
                React.createElement(Accordion.Title, { active: scalesExpanded, onClick: this.toggleScales },
                    React.createElement(Icon, { name: 'dropdown' }),
                    "Scales"),
                React.createElement(Accordion.Content, { active: scalesExpanded },
                    React.createElement(Grid, { columns: 5, stackable: true },
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, null, this.renderNumericField('/amplifierComponent/pretreatADewaxUl', 'Pretreat A (µL)', detectState.pretreatADewaxUl, this.onPretreatADewaxUlChange, scalesDisabled)),
                            React.createElement(Grid.Column, null, this.renderNumericField('/amplifierComponent/pretreatBAntigenRetrievalUl', 'Pretreat B (µL)', detectState.pretreatBAntigenRetrievalUl, this.onPretreatBAntigenRetrievalUlChange, scalesDisabled)),
                            React.createElement(Grid.Column, null, this.renderNumericField('/amplifierComponent/pretreatBloxolUl', 'Pretreat Bloxol (µL)', detectState.pretreatBloxolUl, this.onPretreatBloxolUlChange, scalesDisabled)),
                            React.createElement(Grid.Column, null),
                            React.createElement(Grid.Column, null)),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, null, this.renderNumericField('/amplifierComponent/detectAUl', 'Detect A (µL)', detectState.detectAUl, this.onDetectAUlChange, scalesDisabled)),
                            React.createElement(Grid.Column, null, this.renderNumericField('/amplifierComponent/detectBPmol', 'Detect B (pmol)', detectState.detectBPmol, this.onDetectBPmolChange, scalesDisabled)),
                            React.createElement(Grid.Column, null, this.renderNumericField('/amplifierComponent/detectBConcentration', 'Detect B Concentration', detectState.detectBConcentration, this.onDetectBConcentrationChange, scalesDisabled)),
                            React.createElement(Grid.Column, null, this.renderNumericField('/amplifierComponent/detectBUl', 'Detect B (µL)', detectState.detectBUl, this.onDetectBUlChange, scalesDisabled)),
                            React.createElement(Grid.Column, null, this.renderNumericField('/amplifierComponent/detectCUl', 'Detect C (µL)', detectState.detectCUl, this.onDetectCUlChange, scalesDisabled))),
                        detectState.channels.map(function (channelState, index) {
                            return _this.renderChannelDetectScales(channelState, index, scalesDisabled);
                        }),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, null, this.renderNumericField('/amplifierComponent/postProcessAUl', 'Post Process A (µL)', detectState.postProcessAUl, this.onPostProcessAUlChange, scalesDisabled)),
                            React.createElement(Grid.Column, null, this.renderNumericField('/amplifierComponent/postProcessBUl', 'Post Process B (µL)', detectState.postProcessBUl, this.onPostProcessBUlChange, scalesDisabled)),
                            React.createElement(Grid.Column, null, this.renderNumericField('/amplifierComponent/preHybridizationUl', 'Pre-Hybridization (µL)', detectState.preHybridizationUl, this.onPreHybridizationUlChange, scalesDisabled)),
                            React.createElement(Grid.Column, null),
                            React.createElement(Grid.Column, null))))),
            React.createElement(Grid, { columns: 4, stackable: true },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null),
                    React.createElement(Grid.Column, null),
                    React.createElement(Grid.Column, null),
                    priceColumn(this.priceDisplay())),
                this.props.enableCustomPrice &&
                    React.createElement(CustomPriceRow, { customPrice: this.props.detectState.customPrice, defaultEffectivePriceCents: this.props.priceCents, disabled: this.props.customPriceLocked, errorPathPrefix: '/amplifierComponent', errors: this.props.errors, onPriceChange: this.onCustomPriceChange, onUserInput: this.props.onUserSelection })),
            React.createElement(ErrorDisplay, { errors: this.props.errors, errorPath: "/amplifierComponent" }));
    };
    return AmplifierForm;
}(React.Component));
export { AmplifierForm };
//# sourceMappingURL=AmplifierForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/automated-pro/AmplifierForm.js
// module id = 591
// module chunks = 0